import React, { useEffect, useState } from "react";
import CustomerForm from "./CustomerForm";
// import CustomerList from "./CustomerList";
import logo from "./logo.png";
import StaffCustomerList from "./StaffCustomerList";
import { Api } from "../Api/Api";


const StaffCustomersPage = () => {
  const [customers, setCustomers] = useState([]);
  const [showForm, setShowForm] = useState(false);
  const [editingCustomer, setEditingCustomer] = useState(null);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    loadCustomers();
  }, []);

  const loadCustomers = async () => {
    setLoading(true);
    try {
    //   const res = await fetch("http://localhost/erp/customers/list.php");
    const res = await fetch(`${Api}customers/list.php`);

      // const data = await res.json();
      // setCustomers(data.customers || []);
      const data = await res.json();

      // ❌ Remove closed customers
      const activeCustomers = (data.customers || []).filter(
        (c) =>
          c.status?.toLowerCase() !== "close" &&
          c.status?.toLowerCase() !== "closed",
      );

      setCustomers(activeCustomers);

    } catch (err) {
      console.error("Error loading customers:", err);
    }
    setLoading(false);
  };

  const handleFormSuccess = () => {
    loadCustomers();
    setShowForm(false);
    setEditingCustomer(null);
  };

  const handleEdit = (customer) => {
    setEditingCustomer(customer);
    setShowForm(true);
  };

  const handleDelete = async (id) => {
    if (
      !window.confirm("Are you sure you want to delete this customer record?")
    )
      return;

    try {
    //   const res = await fetch("http://localhost/erp/customers/delete.php", {
    const res = await fetch(`${Api}customers/delete.php`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ id }),
    });

      const data = await res.json();
      if (data.status) {
        loadCustomers();
      } else {
        alert("Delete failed");
      }
    } catch (err) {
      console.error("Error deleting customer:", err);
    }
  };

  return (
    <div
      style={{ fontFamily: "'Inter', sans-serif" }}
      className="relative min-h-screen bg-gray-50 p-8 overflow-hidden"
    >
      {/* <div className="max-w-7xl mx-auto space-y-8"> */}
      <div className="relative z-10 max-w-7xl mx-auto space-y-8">
        {/* Header Section */}
        <div className="flex flex-col md:flex-row md:items-center justify-between gap-4 border-b border-gray-200 pb-6">
          <div>
            <h1 className="text-3xl font-extrabold text-gray-900 tracking-tight">
              Customer Management
            </h1>
            <p className="text-gray-500 mt-2 text-sm">
              Overview and administration of customer investments and portfolio
              status.
            </p>
          </div>

          {!showForm && (
            <button
              onClick={() => {
                setEditingCustomer(null);
                setShowForm(true);
              }}
              className="inline-flex items-center px-5 py-2.5 bg-indigo-600 hover:bg-indigo-700 text-white text-sm font-semibold rounded-lg shadow-sm transition-all duration-200"
            >
              <span className="mr-2">+</span> Register New Customer
            </button>
          )}
        </div>

        {/* Content Area */}
        <div className="transition-all duration-300">
          {showForm ? (
            <div className="max-w-3xl mx-auto">
              <CustomerForm
                customer={editingCustomer}
                onSuccess={handleFormSuccess}
                onCancel={() => {
                  setShowForm(false);
                  setEditingCustomer(null);
                }}
              />
            </div>
          ) : (
            <div className="bg-white rounded-xl shadow-sm border border-gray-200 overflow-hidden">
              <div className="px-6 py-4 border-b border-gray-100 bg-gray-50/50">
                <h2 className="text-lg font-bold text-gray-800">
                  Master Customer Registry
                </h2>
              </div>

              {loading ? (
                <div className="p-12 text-center">
                  <div className="animate-spin inline-block w-8 h-8 border-4 border-indigo-500 border-t-transparent rounded-full mb-4"></div>
                  <p className="text-gray-500 font-medium">
                    Synchronizing data...
                  </p>
                </div>
              ) : (
                <StaffCustomerList
                  customers={customers}
                  onEdit={handleEdit}
                  onDelete={handleDelete}
                />
              )}
            </div>
          )}
        </div>
      </div>
      {/* ✅ WATERMARK LOGO */}
      {/* <img
        src={logo}
        alt="Watermark"
        className="
    absolute inset-0 m-auto
    w-[700px]
    opacity-20
    pointer-events-none
    z-0
    grayscale
    brightness-150
    contrast-75
  "
      /> */}
    </div>
  );
};

export default StaffCustomersPage;